// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3TlWL","content":"styles_content__27cKZ","checkbox":"styles_checkbox__SrkCv","checkboxLabel":"styles_checkboxLabel__2vIri"};